import { useContext, useEffect } from 'react';
import { LFC } from '../../types';
import { ShellContext } from './Header';

export const HideBotMenu: LFC = () => {
  const {
    hideMenu: [, setHidden],
  } = useContext(ShellContext);

  useEffect(() => {
    setHidden(true);

    return () => {
      setHidden(false);
    };
  }, [setHidden]);

  return null;
};
